var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightPink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 18.44"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arrow-right-pink_svg__cls-1{fill:#e81f76}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-pink_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "arrow-right-pink_svg__cls-1",
    d: "M27.09 0l-1.54 1.65 6.93 6.44H0v2.25h32.48l-6.93 6.45 1.54 1.65L37 9.22 27.09 0z",
    id: "arrow-right-pink_svg__TOP_BANNER",
    "data-name": "TOP BANNER"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNyAxOC40NCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNlODFmNzY7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJUT1BfQkFOTkVSIiBkYXRhLW5hbWU9IlRPUCBCQU5ORVIiPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIyNy4wOSAwIDI1LjU1IDEuNjUgMzIuNDggOC4wOSAwIDguMDkgMCAxMC4zNCAzMi40OCAxMC4zNCAyNS41NSAxNi43OSAyNy4wOSAxOC40NCAzNyA5LjIyIDI3LjA5IDAiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgArrowRightPink as ReactComponent };